import { useState } from 'react';
import { faqs } from '../../../mocks/faqs';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-32">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="mb-12">
          <p className="text-gray-500 text-sm uppercase tracking-wider mb-3">
            (DÚVIDAS FREQUENTES)
          </p>
          <h2 className="font-serif font-bold text-5xl lg:text-6xl text-black leading-tight">
            Tudo o que Você Precisa Saber sobre o ATMOS
          </h2>
        </div>

        {/* Accordion */}
        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 flex items-center justify-between text-left cursor-pointer hover:text-primary transition-colors"
              >
                <h3 className="font-medium text-lg lg:text-xl text-black pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  } text-2xl text-primary flex-shrink-0 transition-transform`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'
                }`}
              >
                <p className="text-gray-700 text-base leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Não encontrou sua resposta?</p>
          <a
            href="https://wa.me/5541988674555?text=Olá! Tenho algumas dúvidas sobre o ATMOS."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-primary text-white px-8 py-4 rounded-full font-semibold hover:bg-primary/90 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-customer-service-line text-xl"></i>
            <span>Falar com Consultor</span>
          </a>
        </div>
      </div>
    </section>
  );
}
